import { Loader } from '@rocketlane/ui';
import React, { useState } from 'react';

interface ImageViewerProps {
  url: string;
  name: string;
}

export const ImageViewer: React.FC<ImageViewerProps> = ({ url, name }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = () => {
    setError('Unable to load image. Please check the file URL.');
    setLoading(false);
  };

  if (error) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          fontSize: '16px',
          color: '#ff4d4f',
        }}
      >
        {error}
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {loading && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            fontSize: '16px',
            color: '#666',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'white',
            zIndex: 1,
          }}
        >
          <Loader size={32} />
        </div>
      )}
      <img
        src={url}
        alt={name}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
          border: '1px solid #e0e0e0',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
    </div>
  );
};
